// src/features/dashboard/components/AvailabilityBar.tsx

import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { useTranslate } from 'react-admin';
import { DashboardSummaryResponse } from '../types';

interface AvailabilityBarProps {
  data: DashboardSummaryResponse;
}

const AvailabilityBar: React.FC<AvailabilityBarProps> = ({ data }) => {
  const translate = useTranslate();
  
  // Calculate availability percentage
  const availabilityRate = data.totalLockers > 0
    ? ((data.availableLockers / data.totalLockers) * 100).toFixed(1)
    : '0.0';

  return (
    <Card sx={{
      mb: 3,
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    }}>
      <CardContent sx={{ 
        p: 2.5,
        '&:last-child': { pb: 2.5 }
      }}>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 2 
        }}>
          <CheckCircle sx={{ 
            color: '#4caf50', 
            fontSize: 24 
          }} />
          
          <Typography 
            variant="h4" 
            sx={{ 
              fontWeight: 'bold',
              color: '#4caf50'
            }}
          >
            {availabilityRate}%
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{ 
              color: 'text.secondary',
              fontSize: '0.9rem'
            }}
          >
            {translate('resources.dashboard.average_availability')}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AvailabilityBar;